import { render, staticRenderFns } from "./TaxCatalogManager.vue?vue&type=template&id=790f55c1&scoped=true"
import script from "./TaxCatalogManager.vue?vue&type=script&lang=js"
export * from "./TaxCatalogManager.vue?vue&type=script&lang=js"
import style0 from "./TaxCatalogManager.vue?vue&type=style&index=0&id=790f55c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790f55c1",
  null
  
)

export default component.exports